/* 新建一个 cos.js，导出 cos 实例 */
import COS from 'cos-js-sdk-v5'; // 通过 npm 安装的 SDK
// console.log(COS,2222222)
// var COS2 = require('cos-js-sdk-v5');
// console.log(COS2,2222223)
const cos = new COS({
  SecretId: 'AKID5uCLUL3HNhkV2RnBWaN2dAyjFVeap2Ye',
  SecretKey: '6vTJXYEi4D69uPi1Al6BxUJzLPPSErBF',

  // getAuthorization 必选参数
  // getAuthorization: function (options, callback) {
  //   // 服务端例子：https://github.com/tencentyun/qcloud-cos-sts-sdk/blob/master/scope.md
  //   // 异步获取临时密钥
  //   var url = 'http://example.com/server/sts.php'; // url 替换成您自己的后端服务
  //   var xhr = new XMLHttpRequest();
  //   xhr.open('POST', url, true);
  //   xhr.setRequestHeader('Content-Type', 'application/json');
  //   xhr.onload = function (e) {
  //     try {
  //       var data = JSON.parse(e.target.responseText);
  //       var credentials = data.credentials;
  //     } catch (e) {
  //     }
  //     if (!data || !credentials) {
  //       return console.error('credentials invalid:\n' + JSON.stringify(data, null, 2))
  //     };
  //     callback({
  //       TmpSecretId: credentials.tmpSecretId,
  //       TmpSecretKey: credentials.tmpSecretKey,
  //       SecurityToken: credentials.sessionToken,
  //       // 建议返回服务器时间作为签名的开始时间，避免用户浏览器本地时间偏差过大导致签名错误
  //       StartTime: data.startTime, // 时间戳，单位秒，如：1580000000
  //       ExpiredTime: data.expiredTime, // 时间戳，单位秒，如：1580000000
  //       ScopeLimit: true, // 细粒度控制权限需要设为 true，会限制密钥只在相同请求时重复使用
  //     });
  //   };
  //   xhr.send(JSON.stringify(options.Scope));
  // }
});
export default cos